<template>
  <div>
    <el-form
      :inline="true"
      :model="form"
      class="qForm"
      size="small"
      label-width="80px"
    >
      <el-form-item label="委托单号">
        <el-input
          v-model="form.orderId"
          placeholder="请输入委托单号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="发票抬头">
        <el-input
          v-model="form.invoiceTitle"
          placeholder="请输入发票抬头"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="发票金额">
        <div class="flex">
          <el-input
            v-model="form.beginOrderPrice"
            placeholder="请输入"
            clearable
            class="qForm-price"
          ></el-input>
          <span> -- </span>
          <el-input
            v-model="form.endOrderPrice"
            placeholder="请输入"
            clearable
            class="qForm-price"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="发票类型">
        <el-select
          v-model="form.invoiceType"
          placeholder="请选择发票类型"
          clearable
        >
          <el-option
            :label="item"
            :value="key"
            v-for="(item, key) in invoiceTypeMap"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发票状态">
        <el-select
          v-model="form.invoiceApplyStatus"
          placeholder="请选择状态"
          class="demandStatus"
          clearable
        >
          <el-option
            :label="item"
            :value="key"
            v-for="(item, key) in invoiceApplyStatusMap"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="myTable">
      <el-table :data="tableData" v-loading="tableLoading" border>
        <el-table-column
          prop="orderId"
          label="委托单号"
          width="160px"
          align="center"
        >
        </el-table-column>

        <el-table-column prop="invoiceTitle" align="center" label="发票抬头">
          <template slot-scope="scope">
            {{
              scope.row.htInvoiceApplyBaseinfo &&
              scope.row.htInvoiceApplyBaseinfo.invoiceTitle
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          align="center"
          label="发票类型"
          width="115px"
        >
          <template slot-scope="scope">
            {{
              scope.row.htInvoiceApplyBaseinfo &&
              invoiceTypeMap[scope.row.htInvoiceApplyBaseinfo.invoiceType]
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="invoiceAmount"
          label="发票金额（元）"
          width="120px"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="attr" label="发票性质" width="90px">
          <template slot-scope="scope">
            {{
              scope.row.htInvoiceApplyBaseinfo &&
              openingTypeMap[scope.row.htInvoiceApplyBaseinfo.openingType]
            }}
          </template>
        </el-table-column>

        <el-table-column
          prop="invoiceApplyStatus"
          label="发票状态"
          width="100px"
          align="center"
        >
          <template slot-scope="scope">
            {{ invoiceApplyStatusMap[scope.row.invoiceApplyStatus] }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100px">
          <template slot-scope="scope">
            <span class="btn btn-primary" @click="detailClick(scope.row)"
              >发票详情</span
            >
            <!-- <span
              class="btn btn-primary"
              @click="queryMail(scope.row)"
              v-if="
                scope.row.invoiceApplyStatus === '1' &&
                scope.row.htInvoiceApplyBaseinfo.openingType === '0'
              "
              >快递查询</span
            >

            <span
              class="btn btn-primary"
              v-if="
                scope.row.invoiceApplyStatus === '1' &&
                scope.row.htInvoiceApplyBaseinfo.openingType === '1'
              "
              @click="download(scope.row)"
              >下载</span
            > -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页-->
    <Pagination
      :total="totalItem"
      :page="page"
      @pageIndexChange="handlePageChange"
    />
    <!-- 发票详情 -->
    <InvoiceDetailDialog
      v-model="showDetail"
      :invoiceApplyId="invoiceApplyId"
      :invoiceApplyStatusMap="invoiceApplyStatusMap"
    />
    <!-- 快递 -->
    <MailInfoDialog v-model="showMailInfo" :data="mailInfo" />
  </div>
</template>
<script>
import {
  getInvoiceUrl,
  getKuaidiInfo,
  openedInvoiceList,
} from "@/api/userCenter";
import Pagination from "@/components/Pagination/index";
import { INVOICE_APPLY_OUT } from "@/constant/index";
import InvoiceDetailDialog from "./InvoiceDetailDialog";
import MailInfoDialog from "./MailInfoDialog";
export default {
  components: {
    Pagination,
    InvoiceDetailDialog,
    MailInfoDialog,
  },
  data() {
    return {
      form: {
        invoiceApplyStatus: null,
      },
      totalItem: 0,
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
      tableData: [],
      openingTypeMap: {},
      invoiceTypeMap: {},
      invoiceApplyStatusMap: {},
      showDetail: false,
      invoiceApplyId: null,
      showMailInfo: false,
      mailInfo: {},
      tableLoading: false,
      INVOICE_APPLY_OUT,
    };
  },
  created() {
    this.getInvoiceDict();
    this.getTableData();
  },
  methods: {
    handleQuery() {
      this.getTableData();
    },
    handlePageChange(page) {
      this.page = page;
      this.getTableData();
    },
    async getTableData() {
      this.tableLoading = true;
      const { list, totalItem } = await this.$axios
        .post(openedInvoiceList, {
          ...this.page,
          ...this.form,
        })
        .finally(() => {
          this.tableLoading = false;
        });
      this.tableData = list;
      this.totalItem = totalItem;
    },
    async queryMail({ invoiceApplyId }) {
      const data = await this.$axios.post(getKuaidiInfo, { invoiceApplyId });
      if (data && Object.keys(data).length) {
        this.showMailInfo = true;
        this.mailInfo = data;
      }
    },
    // 下载电子发票
    async download({ invoiceApplyId }) {
      const data = await this.$axios.get(getInvoiceUrl, {
        invoiceApplyId,
      });

      if (data) {
        window.open(data, "_blank");
      } else {
        this.$message.error("发票开票中，请稍后再试");
      }
    },
    // 发票详情
    detailClick({ invoiceApplyId }) {
      this.invoiceApplyId = invoiceApplyId;
      this.showDetail = true;
    },
    // 数据字典
    async getInvoiceDict() {
      // 发票性质
      const data = await this.$store.dispatch("getDictData", "opening_type");
      const map = {};
      data.forEach((item) => {
        map[item.dictValue] = item.dictLabel;
      });
      this.openingTypeMap = map;
      // 发票类型
      const res = await this.$store.dispatch("getDictData", "invoice_type");
      const dMap = {};
      res.forEach((item) => {
        dMap[item.dictValue] = item.dictLabel;
      });
      this.invoiceTypeMap = dMap;
      // 发票审核状态
      const invoiceApplyRes = await this.$store.dispatch(
        "getDictData",
        "invoice_apply_status"
      );
      const invoiceApplyStatusMap = {};
      invoiceApplyRes.forEach(({ dictValue, dictLabel }) => {
        invoiceApplyStatusMap[dictValue] = dictLabel;
      });
      this.invoiceApplyStatusMap = invoiceApplyStatusMap;
    },
  },
};
</script>
<style lang="scss" scoped>
.qForm {
  ::v-deep.el-form-item {
    margin-bottom: 10px;
  }
  &-price {
    width: 100px;
  }
}
.myTable {
  margin-bottom: 10px;
  min-height: 500px;
}
.btn {
  margin: 0 5px;
  cursor: pointer;
  // &:last-child {
  //   margin-right: 0;
  // }
  &-primary {
    color: #409eff;
  }
  &-danger {
    color: #f56c6c;
  }
}
</style>
